import { NgModule } from '@angular/core';
import { CrmResyncWarningDialogComponent } from './crm-resync-warning-dialog.component';
import { CrmResyncWarningDialogService } from './crm-resync-warning-dialog.service';
import { SiModalModule } from '../../../../../shared/components';

@NgModule({
  imports: [SiModalModule],
  declarations: [CrmResyncWarningDialogComponent],
  providers: [CrmResyncWarningDialogService],
})
export class CrmResyncWarningDialogModule {

}
